import { defineMessages } from "@/i18n";
import en from "./en";

export const firstRunMessages = defineMessages("first-run", en);
